import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "section lg:text-center" }

import ArticleModalContent from '@/components/ArticleModalContent.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Karies',
  emits: ["close", "navigate"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_a_circular_image = _resolveComponent("a-circular-image")!

  return (_openBlock(), _createBlock(ArticleModalContent, {
    title: _ctx.$t('articles.karies.title'),
    cover: require('@/assets/covers/kompoziti.jpg'),
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.karies.intro')), 1),
        _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.karies.preventivaTitle')), 1),
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/photos/preventiva.jpg'),
          float: "left"
        }, null, 8, ["image"]),
        _createElementVNode("p", {
          innerHTML: _ctx.$t('articles.karies.preventivaP')
        }, null, 8, _hoisted_2),
        _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.karies.zascitaTitle')), 1),
        _createElementVNode("p", {
          innerHTML: _ctx.$t('articles.karies.zascitaP')
        }, null, 8, _hoisted_3),
        _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.karies.zdravljenjeTitle')), 1),
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/photos/kompoziti.jpg')
        }, null, 8, ["image"]),
        _createElementVNode("p", {
          innerHTML: _ctx.$t('articles.karies.zdravljenjeP1')
        }, null, 8, _hoisted_4),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.karies.zdravljenjeP2')), 1),
        _createElementVNode("p", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('articles.karies.zdravljenjeP3_1')), 1),
          _createElementVNode("b", {
            class: "internal-link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navigate', 'pregledi')))
          }, _toDisplayString(_ctx.$t('articles.karies.zdravljenjeP3_2')), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('articles.karies.zdravljenjeP3_3')), 1)
        ])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.karies.cenikPre')), 1),
          _createElementVNode("b", {
            class: "internal-link",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('navigate', 'cenik', 'zobne-bolezni')))
          }, _toDisplayString(_ctx.$t('articles.karies.cenikLinkText')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.karies.cenikPost')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "cover"]))
}
}

})